import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';

import { EventType } from '../schedule/models/schedule-event.model';
import { ScheduleItem } from '../schedule/models/schedule.model';

@Component({
    selector: '[cmpsScheduleCell]',
    template: ` <div
            class="sc-other-count"
            *ngIf="_otherCount > 0"
        >
            <button
                class="btn bg-transparent p-0"
                data-e2e="button-other"
                (click)="otherClick.emit()"
            >
                <span>+{{ _otherCount }}</span>
            </button>
        </div>
        <div class="d-flex flex-column m-auto">
            <ng-container *ngFor="let i of _top">
                <div
                    cmpsScheduleItem
                    [item]="i"
                ></div>
            </ng-container>
        </div>`,
    host: {
        'data-e2e': 'component-schedule-cell',
    },
})
export class ScheduleCellComponent implements OnChanges {
    @Input() type: EventType;
    @Input() schedule: ScheduleItem[];
    @Output() otherClick: EventEmitter<void>;

    /** @private */ _top: ScheduleItem[];
    /** @private */ _otherCount: number;

    constructor() {
        this.otherClick = new EventEmitter();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('schedule')) {
            const items = (this.schedule || []).filter(
                (e) => e.eventTypeId === this.type,
            );
            this._top = items.slice(0, 2);
            this._otherCount = items.length - 2;
        }
    }
}
